import { MutationTree } from 'vuex'
import { ItemMenu, NavigationState, SetAlertSidebarRequest } from './types'

export enum NavigationMutations {
  SET_ACTIVE_MENU = 'SET_ACTIVE_MENU',
  SET_EXPANDED_MENU = 'SET_EXPANDED_MENU',
  SET_SELECTED_MENU = 'SET_SELECTED_MENU',
  SET_HIDE_SIDEBAR = 'SET_HIDE_SIDEBAR',
  SET_ALERT_SIDEBAR = 'SET_ALERT_SIDEBAR',
  SET_LOADING_PAGE = 'SET_LOADING_PAGE',
  SET_WIDTH_WINDOW = 'SET_WIDTH_WINDOW'
}

export const mutations: MutationTree<NavigationState> = {
  [NavigationMutations.SET_ACTIVE_MENU](state, menuItem: ItemMenu) {
    if (!menuItem.active) {
      state.menuItems.forEach(item => (item.active = false))
      menuItem.active = true
      state.menuItems[(menuItem.id as number) - 1] = menuItem
    }
  },

  [NavigationMutations.SET_EXPANDED_MENU](state, payload: boolean) {
    state.expanded = payload
  },
  [NavigationMutations.SET_LOADING_PAGE](state, payload: boolean) {
    state.loadingPage = payload
  },
  [NavigationMutations.SET_SELECTED_MENU](status: NavigationState, menuId) {
    const currentSelected = status.menuItems.findIndex((item: ItemMenu) => {
      return item.active == true
    })

    const newSelected = status.menuItems.findIndex((item: ItemMenu) => {
      return item.id == menuId
    })

    status.menuItems[currentSelected].active = false
    status.menuItems[newSelected].active = true
  },
  [NavigationMutations.SET_HIDE_SIDEBAR](state, payload: boolean) {
    state.hideSidebar = payload
  },
  [NavigationMutations.SET_ALERT_SIDEBAR](
    state,
    payload: SetAlertSidebarRequest
  ) {
    let items = [...state.menuItems]
    let item = state.menuItems.find(x => x.id == payload.id)
    if (item != undefined) item.alert = payload.value
    state.menuItems = items
  },
  [NavigationMutations.SET_WIDTH_WINDOW](state, payload: number) {
    state.widthWindow = payload
    if (payload < 768) {
      state.deviceType = 3
    } else if (payload < 1024) {
      state.deviceType = 2
    } else {
      state.deviceType = 1
    }
  }
}
